import { loginSuccess } from "../store/authSlice";
import { trackUserAuthenticated } from "../analytics/analytics";
import { ANALYTICS_AUTH_METHODS } from "../analytics/analytics.constants";

export function normalizeBackendUser(user) {
  return {
    uid: user.id,
    display_name: user.full_name,
    email: user.email,
    photo_url: user.photo_url || null,
    email_verified: true,
    is_anonymous: false,
  };
}

export function normalizeFirebaseUser(user) {
  return {
    uid: user.uid,
    display_name: user.displayName,
    email: user.email,
    photo_url: user.photoURL,
    email_verified: user.emailVerified,
    api_key: user.apiKey,
    is_anonymous: user.isAnonymous,
  };
}

export function setAuthSession(
    dispatch,
    user,
    accessToken,
    { method = ANALYTICS_AUTH_METHODS.EMAIL, isNewUser = false, analyticsParams = {} } = {}
) {
    const normalized = user.id ? normalizeBackendUser(user) : user;
    dispatch(loginSuccess(normalized));
    localStorage.setItem("authToken", accessToken);

    const userId = normalized.uid ?? user.uid ?? user.id;
    trackUserAuthenticated({
        userId,
        method,
        isNewUser,
        extraParams: analyticsParams,
    });
}

export function setGoogleAuthSession(
    dispatch,
    firebaseUser,
    accessToken,
    { method = ANALYTICS_AUTH_METHODS.GOOGLE, isNewUser = false, analyticsParams = {} } = {}
) {
    const minimalUserData = normalizeFirebaseUser(firebaseUser);
    dispatch(loginSuccess(minimalUserData));
    localStorage.setItem("googleAuthUser", JSON.stringify(minimalUserData));
    localStorage.setItem("authToken", accessToken);

    trackUserAuthenticated({
        userId: minimalUserData.uid,
        method,
        isNewUser,
        extraParams: analyticsParams,
    });
}
